import { render, staticRenderFns } from "./Addin.vue?vue&type=template&id=4a8ca600&"
import script from "./Addin.vue?vue&type=script&lang=js&"
export * from "./Addin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports